import React, {useState, useEffect, useRef} from 'react'

import MassAdditionListControl from '@/components/mass-addition/MassAditionListControl'
import MassAdditionListInfo from '@components/mass-addition/MassAdditionListInfo';

import {
    MassAdditionAcceptHandle,
    MassAdditionAcceptValue,
    MassAdditionCreateForm,
    MassAdditionFormCreateHandle
} from '@/types/MassAddition';
import type { File } from '@/types/Files';

import './styles/mass-addition-accept.scss';
import { forwardRef, useImperativeHandle } from "react";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";

interface Props {
    files: File[],
    form: MassAdditionCreateForm,
}

const MassAdditionAccept = forwardRef<MassAdditionFormCreateHandle>(({ files, form }: Props, ref) => {
    const [listFiles, setListFiles] = useState<File[]>([])

    const RefListControl = useRef<MassAdditionAcceptHandle>(null)

    const getValue = (): MassAdditionAcceptValue => {
        return {
            files: listFiles
        }
    };

    const showLoader = (type) => {
        RefListControl.current.showLoader(type)
    }

    const updateFilesOrder = (updatedFiles: File[]) => {
        setListFiles(updatedFiles)
    };

    // @ts-ignore
    useImperativeHandle(ref, ():{ getValue: () => MassAdditionAcceptValue } => ({
        getValue,
        showLoader,
    }));

    useEffect(() => {
        setListFiles(files)
    }, [files])

    return (
        <div className={'mass-addition-accept'}>
            <MassAdditionListInfo list={files} form={form} />
            <MassAdditionListControl list={files} form={form} update={updateFilesOrder} ref={RefListControl} />
        </div>
    );
});

export default MassAdditionAccept;